import "./style.scss";

import React, { useContext, useEffect, useRef, useState } from "react";

import { AppStateContext } from "../../state/provider";
import { CfmWidget } from "../CfmWidget";
import { getRepeatContactFeedbackWidgetConfig } from "../CfmWidget/config";
import { useMounted } from "../hooks/common";

export const RepeatContactSurvey: React.FC<unknown> = () => {
  const refCurrentViewedContactId = useRef<string>(); // This is use to keep track of the current contact on the screen.
  const mounted = useMounted();
  const appState = useContext(AppStateContext);
  const [displaySurvey, setDisplaySurvey] = useState<boolean>(false);

  const isEndedRepeatContact = (contact: connect.Contact): boolean => {
    console.log(contact.getAttributes());
    // if a contact has an omniaCaseId, it is a repeat contact
    return (
      contact.getState().type === connect.ContactStateType.ENDED &&
      !!contact.getAttributes().omniaCaseId?.value
    );
  };

  /**
   * This function returns the contact object of the specified contact id corresponding to an agent
   * @param agent the agent object.
   * @param contactId the contactId in Amazon Connect.
   * @returns
   */
  const findContact = (
    agent: connect.Agent,
    contactId: string
  ): connect.Contact | undefined => {
    const contact = agent
      .getContacts()
      .find((contact) => contact.contactId === contactId);
    return contact;
  };

  useEffect(() => {
    if (appState.ccpInitialized) {
      connect.agent((agent) => addConnectEventListeners(agent));
    }
  }, [appState.ccpInitialized]);

  // add connect event listeners
  const addConnectEventListeners = (agent: connect.Agent): void => {
    // get contact id of current contact in view
    // subscribe to changes in the viewed contact and
    // display the survey if the contact in view is an ended repeat contact
    connect.core.onViewContact((viewedContact) => {
      if (mounted.current) {
        refCurrentViewedContactId.current = viewedContact.contactId;
        const contact = findContact(agent, viewedContact.contactId);
        if (contact) {
          setDisplaySurvey(isEndedRepeatContact(contact));
        } else {
          setDisplaySurvey(false);
        }
      }
    });
    connect.contact((contact) => {
      // display the survey if the contact in view is an ended repeat contact
      contact.onEnded((contact) => {
        if (mounted.current) {
          if (refCurrentViewedContactId.current === contact.contactId) {
            setDisplaySurvey(isEndedRepeatContact(contact));
          }
        }
      });
    });
  };

  return displaySurvey ? (
    <div className="repeat-contact-survey-container">
      <CfmWidget
        contactID={refCurrentViewedContactId.current}
        configFunc={getRepeatContactFeedbackWidgetConfig}
      ></CfmWidget>
    </div>
  ) : (
    <></>
  );
};
